import { uploadData } from "aws-amplify/storage";
import { Platform } from "react-native";

import { t } from "@/localization";

let RNFS = null;
let Upload = null;
if (Platform.OS !== "web") {
  RNFS = require("react-native-fs").default;
  Upload = require("react-native-upload").default;
}

import AppConfig from "../../AppConfig";
import { convertVideo } from "../http/events";

//Use to output uploading request information
const LOG_UPLOAD = __DEV__;
const DEFAULT_VIDEO_CONTENT_TYPE = "video/quicktime";

const getFileExtension = (value = "") => {
  const cleanValue = `${value}`.split("?")[0];
  const maybeExtension = cleanValue.split(".").pop();
  if (!maybeExtension || maybeExtension === cleanValue) return "";
  return maybeExtension.toLowerCase();
};

const normalizeVideoContentType = (contentType, filename, fileUri) => {
  if (typeof contentType === "string" && contentType.startsWith("video/")) {
    return contentType;
  }

  const extension = getFileExtension(filename || fileUri);
  if (extension === "mp4" || extension === "m4v") return "video/mp4";
  if (extension === "mov" || extension === "qt") return "video/quicktime";

  return DEFAULT_VIDEO_CONTENT_TYPE;
};

const ensureFileUri = (path) =>
  path?.startsWith("file://") ? path : `file://${path}`;

const resolveIosVideoUri = async (uri, filename) => {
  if (!uri || Platform.OS !== "ios") return uri;
  if (uri.startsWith("file://") || uri.startsWith("assets-library://")) {
    return uri;
  }
  if (uri.startsWith("/")) {
    return ensureFileUri(uri);
  }
  if (!uri.startsWith("ph://")) {
    return uri;
  }

  const extension = getFileExtension(filename || uri) || "mov";
  const separator = RNFS.TemporaryDirectoryPath.endsWith("/") ? "" : "/";
  const tempPath = `${
    RNFS.TemporaryDirectoryPath
  }${separator}eventlive-video-${Date.now()}.${extension}`;
  await RNFS.copyAssetsVideoIOS(uri, tempPath);

  return ensureFileUri(tempPath);
};

export const getFilename = ({ slug, username, file_uri, filename }) => {
  const [extension, ...parts] = filename.split(".").reverse();
  // Add random number to support replacing the file with same filename, get rid of bad chars:
  const fname = (
    parts.reverse().join("-") +
    "_" +
    Math.round(Math.random(0, 1) * 10000) +
    "." +
    extension
  ).replace(/[^\w\d-]/g, "-");
  console.log(filename, file_uri, extension, username, slug, fname);
  return `${username}/${slug}/${fname}`;
};

export const getUploadParams = async ({ stream_key, file, contentType }) => {
  var name = (file.name ?? file).replace(/^.*[\\\/]/, "");
  // const contentType = file.type; //|| getContentTypeFromFile(file.name ?? file);
  // Lambda to get pre-signed upload url:
  const response = await fetch(
    `https://vauoabelw3.execute-api.us-east-1.amazonaws.com/prod/`,
    {
      method: "POST",
      body: JSON.stringify({
        stream_key,
        name: name.replace(/[^\.\w]/g, "-"),
        contentType,
      }),
    }
  );
  const json = await response.json();

  const { url, key } = json;
  const vod_filename = `s3://eventlivehls/${key}`;

  return {
    url,
    key,
    vod_filename,
  };
};

export const vodEventMutation = async (
  slug,
  vod_filename,
  notifyGuests,
  mode,
  insertIndex
) => {
  console.log("vodEventMutation", notifyGuests, mode, insertIndex);
  try {
    return await convertVideo(
      slug,
      vod_filename,
      notifyGuests,
      mode,
      insertIndex
    );
  } catch (error) {
    console.error(error);
    return { errors: true };
  }
};

export const coverUpload = async ({ event, file, filename, onProgress }) => {
  const { slug, broadcaster } = event;
  const key = getFilename({ slug, username: broadcaster, filename });
  try {
    // return await Storage.put(key, file, {
    //   bucket: AppConfig.REACT_APP_COVER_BUCKET,
    //   region: "us-east-1",
    //   progressCallback: onProgress,
    // // });
    const uploadTask = uploadData({
      path: key,
      data: file,
      options: {
        contentType: "image/jpeg",
        bucket: {
          bucketName: AppConfig.REACT_APP_COVER_BUCKET,
          region: "us-east-1",
        },
        accessLevel: "public-read",
        onProgress,
      },
    });

    return await uploadTask.result;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const videoUpload = async ({ file, stream_key, onUploadProgress }) => {
  const contentType = file.type;

  const { url, key, vod_filename } = await getUploadParams({
    stream_key,
    file,
    contentType,
  });

  console.log("url", url);
  console.log("key", key);
  console.log("vod_filename", vod_filename);

  try {
    const result = await uploadData({
      path: `${key}`,
      data: file,
      options: {
        contentType,
        useAccelerateEndpoint: true,
        bucket: {
          bucketName: "eventlivehls",
          region: "us-east-1",
        },
        accessLevel: "guest",
        onProgress: onUploadProgress,
      },
    }).result;

    console.log("result", result);

    return vod_filename;
  } catch (err) {
    console.log("error in upload");
    console.error(err);
    throw err;
  }
};

/**
 * @description Only used on mobile native devices.
 * @param {*} param0
 */
export const backgroundUpload = async ({
  event,
  file_uri,
  filename,
  contentType,
  onComplete,
  onProgress,
  customUploadId,
}) => {
  if (typeof onComplete !== "function")
    console.error("onComplete should be a function");
  if (!file_uri) {
    const fileError = new Error("file_uri should not be null");
    console.error(fileError);
    throw fileError;
  }

  const { stream_key } = event;
  const normalizedFileUri = await resolveIosVideoUri(file_uri, filename);
  const normalizedContentType = normalizeVideoContentType(
    contentType,
    filename,
    normalizedFileUri
  );

  const uploadDescriptor = {
    name: filename || normalizedFileUri,
  };

  const { url, vod_filename } = await getUploadParams({
    stream_key,
    file: uploadDescriptor,
    contentType: normalizedContentType,
  });

  console.log(url, vod_filename);

  return Upload.startUpload({
    url,
    path: normalizedFileUri,
    method: "PUT",
    type: "raw",
    customUploadId,
    maxRetries: 2, // set retry count (Android only). Default 2
    headers: {
      // 'content-type': 'application/octet-stream', // Customize content-type
      "x-amz-acl": "public-read",
      "Cache-Control": "max-age=31536000",
      "content-type": normalizedContentType,
    },
    // Below are options only supported on Android
    notification: {
      enabled: true,
    },
    useUtf8Charset: true,
  })
    .then((uploadId) => {
      if (LOG_UPLOAD) console.log("Upload started");

      Upload.addListener("progress", uploadId, (data) => {
        console.log("progress", uploadId, data);
        if (typeof onProgress === "function") {
          onProgress({
            progress: data.progress / 100,
          });
        }
      });

      Upload.addListener("error", uploadId, (data) => {
        if (LOG_UPLOAD) console.log(`Error: ${data.error}%`, data);
      });

      Upload.addListener("cancelled", uploadId, (data) => {
        if (LOG_UPLOAD) console.log(`Cancelled!`, data);
      });

      Upload.addListener("completed", uploadId, (data) => {
        // data includes responseCode: number and responseBody: Object
        //TODO: test if this fails when in background
        if (LOG_UPLOAD) console.log("Completed!", data);

        console.log(vod_filename);

        if (typeof onComplete === "function") onComplete({ vod: vod_filename });
      });
    })
    .catch((err) => {
      if (LOG_UPLOAD) console.log("Upload error!", err);
      if (typeof onComplete === "function") {
        onComplete({
          error: err?.message || t("Failed to start upload"),
        });
      }
      throw err;
    });
};
